import { render, staticRenderFns } from "./RevActionIcons.vue?vue&type=template&id=60432968&scoped=true"
import script from "./RevActionIcons.vue?vue&type=script&lang=js"
export * from "./RevActionIcons.vue?vue&type=script&lang=js"
import style0 from "./RevActionIcons.vue?vue&type=style&index=0&id=60432968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60432968",
  null
  
)

export default component.exports